import Vue from 'vue'
import axios from 'axios'
import qs from 'qs'
import { Message, Loading } from 'element-ui'
// 响应时间
axios.defaults.timeout = 30* 1000
axios.defaults.withCredentials = true
var UserInfo=JSON.parse(sessionStorage.getItem("userinfo"))||{};
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
axios.defaults.headers.get['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
axios.defaults.headers.put['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
axios.defaults.headers['Source'] = 1;


var UserInfo=JSON.parse(sessionStorage.getItem("userinfo"));
var paths=window.location.pathname;
var url = window.location.href;
// console.log(UserInfo,paths)
  if(UserInfo==null&&paths!='/login'&&paths!='/regist'&&paths!='/logginBind'&&!UserInfo&&paths!='/'){
  //     window.location.replace('http://study.ca-sme-lt.com');
  }
Vue.prototype.$static = ''
function ser(obj) {
  var ne = {};
  for (var i in obj) {
    ne[i] = obj[i];
  }
  return ne;
};
let baseURL = 'https://api.ca-sme-lt.com'
// let baseURLA = 'http://apivue.ca-sme-lt.com'//证书左侧列表
// let baseURLB = 'https://api.ca-sme-lt.com'//证书右侧列表
// let baseURLB = 'http://10.0.0.122:8098'//证书右侧列表
//axios.defaults.baseURL = 'http://localhost:52768/'
axios.interceptors.request.use(
  config => {
    // // 添加请求头：token
    var UserInfo=JSON.parse(sessionStorage.getItem("userinfo"))||{};
    // console.log(config,UserInfo)
    if(UserInfo.Token){
      axios.defaults.headers['Token'] = UserInfo.Token;
    }
    if(config.method === 'get'&&config.params.url){
      config.baseURL=config.params.url;
      axios.defaults.headers['Token'] = UserInfo.Token;
    }
    if(config.method==='get'){
      config.params={
        ...ser(config.params)
      }
    }
       
    return config
  },
  err => {
    Message.error('请求错误')
    return 
    // Promise.reject(err)
  }
)
// 返回状态判断(添加响应拦截器)
axios.interceptors.response.use(
  res => {
    return res;
  },
  err => {
    // console.log(err)
    // debugger
    Message.error('请求失败，请稍后再试');
    return 
    // Promise.reject(err);
    // Promise.reject(err)
  }
)

export function fetchPost (url, params,login) {
  axios.defaults.baseURL = baseURL;

  params=params

  return new Promise((resolve, reject) => {
    axios
      .post(url, params)
      .then(
        res => {
          resolve(res.data)
          //Promise.reject(res)
        },
        err => {
          reject(err)
        }
      )
      .catch(err => {
        reject(err)
      })
  })
}
export function fetchPut (url, params) {
  axios.defaults.baseURL = baseURL;
  var data={};
  data.operaterID='';
  data.id='';
  data.operater='';
  data.data=params;
  params=data
  return new Promise((resolve,reject) => {
    axios
      .put(url, params)
      .then(
        res => {
          resolve(res)
          //Promise.reject(res)
        },
        err => {
          reject(err)
        }
      )
      .catch(err => {
        reject(err)
      })
  })
}
export function fetchDelete (url, params,type) {
  axios.defaults.baseURL = baseURL;
  return new Promise((resolve, reject) => {
    axios
      .delete(url, param)
      .then(
        res => {
          resolve(res)
          //Promise.reject(res)
        },
        err => {
          reject(err)
        }
      )
      .catch(err => {
        reject(err)
      })
  })
}
export function fetchGet (url, params,type) {
  axios.defaults.baseURL = baseURL;
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        params: params
      })
      .then(res => {
        // console.log(res)
        resolve(res.data)
      })
      .catch(err => {
        reject(err)
      })
  })
}
export function fetchGetA (url, params,type) {
  axios.defaults.headers['Authorization'] = UserInfo.Token;
  axios.defaults.baseURL = baseURLA;
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        params: params
      })
      .then(res => {
        // console.log(res)
        resolve(res.data)
      })
      .catch(err => {
        reject(err)
      })
  })
}
export function fetchGetB (url, params,type) {
  // axios.defaults.headers['Authorization'] = UserInfo.Token;
  axios.defaults.baseURL = baseURLB;
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        params: params
      })
      .then(res => {
        console.log(res)
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}


// WEBPACK FOOTER //
// ./src/common/js/axiosConfig.js